// extracted by mini-css-extract-plugin
export default {"button":"OpenMapButton_button__ZpIBE","mark":"OpenMapButton_mark__Du95q"};